import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { copy, routeFor } from "@/data/content";
import { Lang } from "@/types";

export function Header({ lang }: { lang: Lang }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const t = copy[lang];
  const other = lang === "de" ? "en" : "de";
  let otherPath = location.pathname.replace(/^\/(de|en)/, `/${other}`);
  const routePairs = other === "en"
    ? [["/leistungen/", "/services/"], ["/orte/", "/areas/"], ["/angebot", "/quote"], ["/impressum", "/imprint"], ["/datenschutz", "/privacy"]]
    : [["/services/", "/leistungen/"], ["/areas/", "/orte/"], ["/quote", "/angebot"], ["/imprint", "/impressum"], ["/privacy", "/datenschutz"]];
  routePairs.forEach(([from, to]) => { otherPath = otherPath.replace(from, to); });
  return <header className="site-header" data-testid="site-header">
    <Link to={`/${lang}`} className="brand" data-testid="header-brand-link"><img src="/assets/piccobello-logo-header.webp" alt="Picco Bello Bioreinigungsmittel Gebäudereinigung" className="brand-logo-header" data-testid="header-logo-image" /></Link>
    <nav className={`nav ${open ? "nav-open" : ""}`} data-testid="main-navigation">
      <a href={`/${lang}#services`} data-testid="nav-services-link">{t.navServices}</a>
      <a href={`/${lang}#areas`} data-testid="nav-areas-link">{t.navAreas}</a>
      <a href={`/${lang}#prices`} data-testid="nav-prices-link">{t.navPrices}</a>
      <Link to={otherPath} className="lang-link" data-testid="language-switch-link">{other.toUpperCase()}</Link>
      <Link to={routeFor(lang, "quote")} className="button button-small" data-testid="header-quote-link">{t.quote}</Link>
    </nav>
    <button className="menu-button" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-button">{open ? <X /> : <Menu />}</button>
  </header>;
}